import type { Locale } from '@/lib/i18n';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const settingsTranslations: Record<Locale, typeof en> = {
  'en-US': en,
  'ar-SA': ar,
};